import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import { withRouter } from 'react-router';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { float } from '../../../../../helpers';
import { formatMortgageTerm } from '../../../../../helpers/mortgage';
import { trackingEvent } from '../../../../../helpers/tracking';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderInput from '../../../../../common/components/render-input';
import logger from '../../../../../helpers/logger';

export const formName = Routes.STEPEIGHT;

const tracking = {
    eventAction: 'Mortgage Calculator - Step 8',
    eventLabel: 'Your Closing Costs'
};

class StepEightForm extends Component {
    componentDidMount() {
        logger.logUserAction('form_step_loaded', 'MortgageCalculator-Step8', {
            step: 8,
            formName: formName,
            url: window.location.href
        });
        this.updateRateFromTerm();
    }

    componentDidUpdate(prevProps) {
        // Log validation errors
        if (this.props.invalid && this.props.submitFailed && this.props.syncErrors) {
            logger.warn('Form validation failed in Step 8', {
                step: 8,
                formName: formName,
                errors: this.props.syncErrors,
                values: this.props.values
            });
        }

        // Only auto-update rate when the selected term changes
        if (prevProps.selectedTerm !== this.props.selectedTerm) {
            this.updateRateFromTerm();
        }
    }

    updateRateFromTerm() {
        const {
            props: {
                changeFieldValue,
                selectedTerm = {}
            }
        } = this;

        if (Object.keys(selectedTerm).length > 0) {
            changeFieldValue('mortgageRate', float(selectedTerm.Rate1).toFixed(2));
        }
    }

    render() {
        return (
            <form className={styles.form}>
                <Field
                    name='mortgageRate'
                    type='number'
                    label='Your estimated mortgage rate'
                    prefix='%'
                    component={RenderInput}
                />
            </form>
        );
    }
}

const stepSevenFormName = Routes.STEPSEVEN;
const stepSevenSelector = formValueSelector(stepSevenFormName);

const mapStateToProps = (state) => ({
    mortgageTerms: state.mortgage.terms,
    selectedTerm: state.mortgage.terms ? state.mortgage.terms.find(({ Range, SubType }) => formatMortgageTerm(Range, SubType) === stepSevenSelector(state, 'mortgageTerm')) : {}
});

const mapDispatchToProps = dispatch => ({
    changeFieldValue: (field, value) => dispatch(change(formName, field, value))
});

// Enhanced onSubmit with logging
const enhancedOnSubmit = async (values, dispatch, props) => {
    try {
        const result = await onSubmit(values, dispatch, props);
        logger.logFormSubmission('MortgageCalculator-Step8', values, true);
        return result;
    } catch (error) {
        logger.error('Step 8 form submission failed', {
            step: 8,
            formName: formName,
            values,
            error: error.message || error
        });
        throw error;
    }
};

StepEightForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    onSubmit: enhancedOnSubmit,
    redirectPath: `/mortgage${Routes.STEPNINE}`,
    tracking: () => trackingEvent(tracking)
})(StepEightForm);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(StepEightForm));
